import { LogOut, ChevronLeft, Users } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Navbar({ showBack = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.role === "admin";

  const doLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="top-stripe">
      <header className="brand-navy text-white" data-testid="app-navbar">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {showBack && (
              <button
                aria-label="Indietro"
                data-testid="navbar-back-button"
                onClick={() => navigate(-1)}
                className="p-2 rounded-full hover:bg-white/10 transition"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
            )}
            <div className="leading-tight">
              <div className="text-xl sm:text-2xl font-extrabold tracking-tight">M. Biella</div>
              <div className="text-[10px] sm:text-xs tracking-[0.22em] font-semibold text-amber-400">
                WORK MANAGER
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            {isAdmin && location.pathname !== "/users" && (
              <button
                onClick={() => navigate("/users")}
                data-testid="navbar-users-button"
                className="px-3 py-2 rounded-lg hover:bg-white/10 transition inline-flex items-center gap-2 text-sm"
                title="Gestione operatori"
              >
                <Users className="w-4 h-4" />
                <span className="hidden sm:inline">Operatori</span>
              </button>
            )}
            {user && (
              <span className="hidden sm:inline text-sm text-slate-200" data-testid="navbar-username">
                {user.name}
              </span>
            )}
            <button
              onClick={doLogout}
              data-testid="navbar-logout-button"
              className="p-2 rounded-full hover:bg-white/10 transition"
              aria-label="Esci"
              title="Esci"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </header>
    </div>
  );
}
